var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4117 23.0254c-2.3307 1.2383-5.0571 1.5029-7.5825.7361-.3854-.1168-.7609-.2645-1.1226-.4418-1.0442-.513-1.9909-1.2043-2.7974-2.0428 3.1555-.215 6.1629-1.4193 8.5947-3.4415.5126-.4237.9868-.8918 1.4172-1.3988l.7545 2.503 1.0123 3.4047c.1656.4234.0736.497-.2762.6811Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12362 12.9213c.17107-1.4911.67418-2.925 1.47232-4.19613L5.47947 1.62116c-.00902-.05784-.03154-.11273-.06575-.16023-.0342-.0475-.07912-.08626-.13111-.11315-.05199-.02689-.10958-.04115-.16811-.04162-.05853-.00046-.11635.01288-.16876.03894-.01916.01109-.03759.02338-.0552.0368-.07268.05139-2.51086 2.40627-3.34956 3.86488C.25269 7.54729-1.0172 15.2402 7.30147 18.553c-1.0045-1.6954-1.41872-3.6759-1.17785-5.6317Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0444.922067C6.29007 1.84227 1.78105 8.46777 3.27178 14.3203c1.43553 5.9077 9.86462 7.6561 15.44112 4.0857-3.184 1.8957-7.2513 1.1963-8.74201-1.9508-1.3619-2.9079.18401-6.51509 3.16551-8.31871 1.1142-.68533 2.3914-1.06023 3.6992-1.08584 5.4476-.05522 7.4904 6.01815 3.5152 10.06705 1.6762-1.5262 2.8289-3.5418 3.2943-5.7605C24.8414 5.22864 19.8278-.0576696 13.0444.922067Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9452 4.36396c-.775-.29553-1.5856-.48736-2.4109-.57052-5.5764-.58893-10.8032 3.5888-11.41054 9.12846-.10832.9196-.0773 1.8503.09202 2.7606.95701 5.0796 6.34362 8.5477 10.92622 6.5231 4.0031-1.7825 7.1244-5.5007 7.7487-9.927.4233-3.1287-1.1541-6.46071-4.9455-7.91464Zm2.411 8.88924c-.6257 3.9753-4.9691 7.0303-8.9628 5.9997-2.687-.6993-4.28816-3.1655-3.84646-5.9997.55216-3.57044 4.12256-6.40468 7.76656-6.18383 3.3495.20244 5.5581 2.92626 5.0427 6.18383Z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7125 16.529c-2.779 2.4846-7.3801 3.7729-10.76642 3.3127-3.03669-.4048-5.13473-1.7851-6.44143-3.6072l-.01842-.0184C-.903025 12.8602-.797989 6.03406 4.68506 1.54107c.04981-.04082.2058-.15918.2058-.15918C3.56578 2.57813-.372585 7.95268 1.79911 12.2592c1.43551 2.8711 4.76667 3.8834 7.98736 3.6257 2.43903-.1692 4.75743-1.1249 6.60713-2.7238.0184 0 .0184-.0184.0368-.0184C21.6387 8.72565 21.7123 1.62169 15.0317.81189c.6003.00574 1.1984.073557 1.7848.20237 1.1707.23186 2.8347 1.14111 3.6629 1.98775 3.2021 3.16549 2.871 9.40449-1.7669 13.52699Z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3869 17.7435c-4.3617 4.233-10.3798 4.8956-14.92566 3.368-2.22691-.7546-4.10413-2.0245-5.263582-3.6624-.055213-.0921-.349679-.4785.165637-.6994l1.435525-.6625c.18404-.0921.29446-.1473.58892.1288 1.87722 1.7484 4.49063 2.5766 7.0856 2.5214C20.4791 18.4429 25.3193 6.77467 19.614 2.37607c-.8466-.68095-2.1533-1.15946-2.7974-1.36191l.092.0184c1.4831.28481 2.8847.89447 4.1041 1.78521 4.5091 3.75443 3.552 10.85843-.6258 14.92573Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0316 2.81722c-.3804-.27639-.7799-.52558-1.1955-.74569 1.2196.7882 2.2247 1.86644 2.9255 3.13823 1.9324 3.47838 1.0123 7.98744-1.8036 11.22654-.4399.4981-.9134.9654-1.4172 1.3987-2.4273 2.0298-5.4373 3.2352-8.5947 3.4417-.7847.0497-1.57192.0435-2.35573-.0185-.11592-.0145-.23361-.0003-.34272.0415-.10912.0417-.20631.1095-.28302.1976l-.79138.8836c-.34969.4049-.18405.6624.14723.736 2.09583.5321 4.28412.5887 6.40462.1658 1.4352-.2717 2.8237-.749 4.1226-1.4172 1.4505-.7395 2.754-1.7373 3.8463-2.9447 1.725-1.8474 2.8426-4.1789 3.2024-6.6807.5338-3.86483-1.0306-7.3432-3.8648-9.42288Z",
    fill: "url(#i)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 22.504,
    y1: 20.316,
    x2: 15.3165,
    y2: 20.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8669F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A3378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 4.00457,
    y1: 12.9093,
    x2: 7.34322,
    y2: 4.2776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2306,
    stopColor: "#7756C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58822,
    stopColor: "#8D58C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE5BC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 10.5496,
    y1: 2.98625,
    x2: 15.8732,
    y2: 17.6126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8669F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 10.2801,
    y1: 3.81779,
    x2: 17.8598,
    y2: 16.9462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F419A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01977,
    stopColor: "#61439D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31236,
    stopColor: "#7861C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58274,
    stopColor: "#8877DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82049,
    stopColor: "#9284EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9689F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 3.69846,
    y1: 17.0022,
    x2: 18.3253,
    y2: 2.37529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9689F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21588,
    stopColor: "#BA82DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49762,
    stopColor: "#E579C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64198,
    stopColor: "#F576BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99445,
    stopColor: "#F569AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F569AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 4.67724,
    y1: 21.1511,
    x2: 22.9151,
    y2: 5.76282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E64DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A159EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74143,
    stopColor: "#E959A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F55196"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 7.5311,
    y1: 19.9681,
    x2: 23.9514,
    y2: 8.47046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#905DD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48212,
    stopColor: "#9A59CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#B64EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87409,
    stopColor: "#E03D8C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h25v25H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .804443)",
    d: "M0 0h25v23.391H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.a3ae311d814a6930f0f68f5aeb12f14d.svg";
export { ForwardRef as ReactComponent };